import { stats } from '@/mocks/data';

export default function DataShowcase() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight tracking-tight">
              用数据说话
              <br />
              实力见证
              <br />
              值得信赖
            </h2>

            <div className="flex items-center gap-0 mt-10">
              {stats.map((stat, idx) => (
                <div key={stat.label} className="flex items-center">
                  {idx > 0 && (
                    <div className="w-px h-16 bg-foreground-200/50 mx-6 md:mx-10"></div>
                  )}
                  <div>
                    <p className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-primary-500 leading-none">
                      {stat.value}
                    </p>
                    <p className="mt-2 text-xs md:text-sm text-foreground-500">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>

            <p className="mt-8 text-sm text-foreground-500 leading-relaxed max-w-md">
              自上线以来，51黑料网已发展成为国内领先的娱乐资讯聚合平台，累计服务超过500万吃瓜群众，独家爆料内容超过10万条。
            </p>
          </div>

          <div className="flex-1 w-full relative">
            <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-primary-100 via-accent-100/50 to-background-100 aspect-[4/3]">
              <div className="absolute top-8 right-8 w-32 h-32 rounded-full bg-primary-500/20 blur-2xl"></div>
              <div className="absolute bottom-10 left-6 w-40 h-40 rounded-full bg-accent-500/20 blur-2xl"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 rounded-full bg-primary-400/15 blur-3xl"></div>

              <div className="relative z-10 p-8 md:p-10 flex flex-col items-center justify-center h-full">
                <div className="grid grid-cols-2 gap-4 w-full max-w-sm">
                  {[
                    { icon: 'ri-fire-line', label: '每日更新', value: '200+篇' },
                    { icon: 'ri-user-smile-line', label: '独家线人', value: '300+位' },
                    { icon: 'ri-timer-flash-line', label: '最快响应', value: '30分钟内' },
                    { icon: 'ri-shield-check-line', label: '事实核查', value: '三重验证' },
                  ].map((item) => (
                    <div
                      key={item.label}
                      className="p-4 rounded-2xl bg-background-50/70 backdrop-blur-sm text-center"
                    >
                      <span className="w-9 h-9 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-2">
                        <i className={`${item.icon} text-base`}></i>
                      </span>
                      <p className="text-lg font-bold text-foreground-950">{item.value}</p>
                      <p className="text-xs text-foreground-500 mt-0.5">{item.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}